import { useEffect } from "react";
import { UserPackageSummary } from "src/models";
import { _ } from "src/services";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";
import { useSelector } from "react-redux";
import { ConfigInit } from "src/store";
import { Link } from "react-router-dom";

export const ProfilePackageBox: React.FC<UserPackageSummary> = ({
    canBuy, id, image, purchaseType, remainingDays, title, gift
}) => {

    const config: ConfigInit = useSelector((state: any) => state.ConfigState);

    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: ".lazy.p" + id,
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            }
        });

        lazyload.update();

    }, [id]);


    return (
        <div className="profile-package">
            <div className="d-flex flex-column flex-md-row justify-content-start">
                <div className="d-flex align-items-center">
                    <img alt="" data-src={image}
                        data-placeholder={phPackage}
                        src={phPackage}
                        className={`package-logo lazy p${id}`} />
                    <h2 className="package-title">
                        <span>{title}</span>
                    </h2>
                </div>
                <div className="flex-1"></div>
                <div className="d-flex align-items-center justify-content-between">
                    <span className={`package-status${remainingDays > 0 ? "" : " ended"}`}>
                        {_(remainingDays > 0 ? "packageDayRemained" : "ended").replace("{day}", "" + remainingDays)}
                    </span>
                    {
                        config.config.appSetting.isPackagingSystemEnabled && canBuy &&
                        <Link className="btn btn-packages" to={`/subscription/${id}`}>{purchaseType === "renew" ? _("renew") : _("rebuy")} </Link>
                    }
                </div>
            </div>
        </div>

    );

};